import React, { useState, useRef, useEffect } from 'react'
import Box from '@mui/material/Box'
import Avatar from '@mui/material/Avatar'
import Icon from '../../../@core/components/icon'
import Typography from '@mui/material/Typography'
import { Button } from '@mui/material'
import { showSnackbar } from '../toast/snackbarService'
import { useUploadFiles } from '../../../hooks/uploadFiles'

const Upload_excel = (props) => {
    // ** Props

    const uploadFile = useUploadFiles()

    const fileInputRefs = useRef(null)
    const [uploadedFiles, setUploadedFiles] = useState(null)
    const [isFileUploading, setIsFileUploading] = useState(false)

    useEffect(() => {
        uploadFile.postUserToken()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleBoxClick = () => {
        if (fileInputRefs.current) {
            fileInputRefs.current.click()
        }
    }

    const handleFileChange = (event) => {
        const selectedFiles = event.target.files[0]
        setUploadedFiles(selectedFiles)
    }

    const resetUploadedFileData = () => {
        setUploadedFiles(null)
        if (fileInputRefs.current) {
            fileInputRefs.current.value = '';
        }
    }

    const submitFiles = async () => {
        const formData = new FormData();

        if (uploadFile.userToken && uploadedFiles) {
            setIsFileUploading(true)
            formData.append("file", uploadedFiles);
            uploadFile.postUploadExcelTrueClaim(formData, (response) => {
                if (response.status === "success") {
                    showSnackbar("Record Upload successfully!", "success");
                    setIsFileUploading(false)
                    setUploadedFiles(null)
                } else {
                    showSnackbar("Something Went Wrong", "error");
                    setIsFileUploading(false)
                    setUploadedFiles(null)
                }
            })
        } else {
            if (uploadedFiles) {
                setIsFileUploading(true)
                uploadFile.postUserToken('', (response) => {
                    if (response.status !== "success") {
                        showSnackbar("Something Went Wrong", "error");
                    }
                });
                uploadFile.postUploadExcelTrueClaim(uploadedFiles, (response) => {
                    if (response.status === "success") {
                        showSnackbar("Record Upload successfully!", "success");
                        setUploadedFiles(null)
                        setIsFileUploading(false)
                    } else {
                        showSnackbar("Something Went Wrong", "error");
                        setUploadedFiles(null)
                        setIsFileUploading(false)
                    }
                })
            } else {
                setIsFileUploading(false)
                showSnackbar(`Select File`, "error")
            }
        }
    }

    const handleUploadRecord = () => {
        // uploadFile.checkUploadStatus('', (response) => {
        //   if (response.status === "success") {
        //     showSnackbar("Upload Process is Running", "success");
        //     setIsFileUploading(false)
        //   } else {
        //     showSnackbar("Something Went Wrong", "error");
        //     setIsFileUploading(false)
        //   }
        // })
    }

    const renderContent = () => {
        return (
            <Box style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '10px', padding: '10px' }}>
                <Box style={{ width: '100%', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    <div >
                        <Box
                            sx={{
                                width: {
                                    xs: '90px',
                                    sm: '100px',
                                    md: '135px',
                                    lg: '150px',
                                },
                                height: {
                                    xs: '90px',
                                    sm: '95px',
                                    md: '115px',
                                    lg: '130px',
                                },
                                borderWidth: 1,
                                display: 'flex',
                                alignItems: 'center',
                                borderRadius: '10px',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                borderStyle: 'solid',
                                borderColor: 'primary.main',
                                cursor: 'pointer',
                                position: 'relative',
                                backgroundColor: (theme) =>
                                    uploadedFiles ? theme.palette.grey[200] : theme.palette.primary.contrastText,
                            }}
                            onClick={() => handleBoxClick()}
                        >
                            <input
                                type="file"
                                ref={fileInputRefs}
                                style={{ display: 'none' }}
                                onChange={(e) => handleFileChange(e)}
                                accept=".xlsx"
                            />
                            <Avatar
                                variant="rounded"
                                sx={{
                                    backgroundColor: 'action.selected',
                                    width: {
                                        xs: '28px',
                                        sm: '32px',
                                        md: '36px',
                                    },
                                    height: {
                                        xs: '28px',
                                        sm: '32px',
                                        md: '36px',
                                    },
                                }}
                            >
                                <Icon icon='ph:file-pdf' style={{ height: '95%', width: '95%' }} />
                            </Avatar>
                            <Typography
                                sx={{
                                    fontWeight: 500,
                                    color: 'text.secondary',
                                    textTransform: 'capitalize',
                                    mt: 2,
                                    fontSize: {
                                        xs: '12px',
                                        sm: '14px',
                                        md: '16px',
                                    },
                                }}
                            >
                                Excel
                            </Typography>
                            <Box
                                sx={{
                                    position: 'absolute',
                                    display: 'flex',
                                    top: 0,
                                    right: 0,
                                    width: {
                                        xs: '16px',
                                        sm: '20px',
                                        md: '24px',
                                    },
                                    height: {
                                        xs: '16px',
                                        sm: '20px',
                                        md: '24px',
                                    },
                                }}
                            >
                                {uploadedFiles ? (
                                    <Icon icon="icon-park-twotone:correct" />
                                ) : (
                                    <Icon icon="line-md:upload-loop" />
                                )}
                            </Box>
                        </Box>
                    </div>
                </Box>
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'end' }}>
                    <Button variant="contained" sx={{ ml: '8px' }} onClick={submitFiles} disabled={isFileUploading}>
                        {isFileUploading ? <Box sx={{ marginLeft: "5px", background: 'transparent', width: '25px', display: 'flex', justifyContent: 'center', alignItems: "center", height: '25px', borderRadius: '50%' }}>
                            <Icon icon="svg-spinners:6-dots-scale" width="16" height="16" color='black' />
                        </Box> : "Upload Files"}
                    </Button>
                    <Button variant="tonal" sx={{ ml: '8px' }} onClick={resetUploadedFileData} disabled={isFileUploading}>
                        {isFileUploading ? <Box sx={{ marginLeft: "5px", background: 'transparent', width: '25px', display: 'flex', justifyContent: 'center', alignItems: "center", height: '25px', borderRadius: '50%' }}>
                            <Icon icon="svg-spinners:6-dots-scale" width="16" height="16" color='black' />
                        </Box> : "Reset"}
                    </Button>
                </Box>
            </Box>
        )
    }

    return renderContent()
}

export default Upload_excel
